import { BusinessType } from "../MoneyTransfer/BusinessType.tsx";
import { NormasTeachingItemType } from "../Stripe/StripeOrderDTO.ts";
import { MoneyDTO } from "../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";
import { PurchasedItemSnapshotDTO } from "../ProductService/PurchasedItem/PurchasedItemSnapshotDTO.ts";

type OrderCustomerInformation = {
  email: string;
  firstName: string;
  lastName: string;
};

type OrderInvoiceInfoDTO =
  | {
      requested: false;
    }
  | {
      requested: true;
      businessType: BusinessType.IndividualCompany;
      pec?: string;
      sdiCode?: string;
      vat: string;
    }
  | {
      requested: true;
      businessType: BusinessType.Person;
    };

type BundleParticipant = {
  products: {
    id: string;
    priceInCents: MoneyDTO;
  }[];
  customer: OrderCustomerInformation;
};

export type HeyLightOrderDTO = {
  _id: string;
  productId: string;
  heyLightInformation: {
    heyLightRedirectUrl: string;
    heyLightExternalContractUuid: string;
    heyLightOrderStatus: HeyLightOrderStatus;
    failureReason?:
      | "credit_check_decline"
      | "id_check_decline"
      | "address_not_found_decline"
      | "success"
      | null;
  };
  amountInCent: {
    amount: number;
    currency: string;
  };
  productType: NormasTeachingItemType;
  customerInformation: OrderCustomerInformation;
  invoiceInfo: OrderInvoiceInfoDTO;
  bundleParticipants?: BundleParticipant[];
  participants?: OrderCustomerInformation[];
  isNewFlow?: boolean;
  numberOfInstallments?: number;
  createdAt: string;
  coupon?: {
    _id: string;
    couponCode: string;
    value: number;
  };
  productSnapshot?: PurchasedItemSnapshotDTO;
};

export enum HeyLightOrderStatus {
  Pending = "pending",
  Cancelled = "cancelled",
  AwaitingConfirmation = "awaiting_confirmation",
  Success = "success",
  Refunded = "refunded",
  PartiallyRefunded = "partially_refunded",
}
